import withHttp from '@/config/withHttp';
var baseURL = '/judgeagent';
/* *************** 庭审中相关接口 ******************* */

var apis = {
  // 获取证据材料
  getDocument: {
    url: '/case/dossierPage',
    method: 'post'
  },
  // 获取归档案件数
  getDocumentCount: {
    url: '/case/dossierCount',
    method: 'get'
  },
  // 搜索档案
  searchDocument: {
    url: '/case/search',
    method: 'post'
  },
  // 更新庭审状态
  changeTrialStatus: {
    url: '/case/reTrial',
    method: 'post'
  }
};
export default withHttp(apis, baseURL);